// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3e3d573d","239":"f55b326d","455":"2bb02e73"}[chunkId] + ".chunk.js";
};